import React, { useEffect, useState } from "react";
import { toggle } from "../../util/common";
import * as services from "../../store/service";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

export interface IAnswerSchema {
    header: string;
    content: string;
    id: number;
}

const FAQ = (props: any) => {
    const [data, setData] = useState([] as IAnswerSchema[]);
    const [filterString, setFilterString] = useState("");
    const [showFAQ, setShowFAQ] = useState(false);
    const [showFAQSection, setShowFAQSection] = useState(true);

    const filter = (e: any) => {
        var filterVal = e.target.value.toLowerCase();
        setShowFAQ(true);
        setFilterString(filterVal);
    };
    const toggleFAQ = () => {
        setShowFAQ(!showFAQ);
    };

    useEffect(() => {
        services
            .getReputationFAQContents()
            .then((data) => {
                if (data && data.hasError === false) {
                    setData(data.faqContents);
                } else {
                    setShowFAQSection(false);
                }
            })
            .catch((error) => {
                setShowFAQSection(false);
            });
    }, []);

    return (
        <React.Fragment>
            {showFAQSection === false ? (
                <div className="container container-table" style={{ backgroundColor: "#F2F6F9" }}>
                    <div className="row vertical-center-row">
                        <div className="text-center col-xs-12 col-xs-offset-0 col-xm-12 col-xm-offset-0">
                            <div className="content-sub-title text-align-center">
                                <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                    <em className="las la-exclamation-circle"></em>
                                </div>
                            </div>
                            <div className="box-content text-align-center">
                                <p>
                                    FAQ service currently unavailable.
                                    <br />
                                    Please try again later.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    {data.length === 0 ? (
                        <div className="box loading"></div>
                    ) : (
                        <div className="drawer-container drawer-container-alt">
                            <div className="drawer-header">
                                <button
                                    aria-expanded={showFAQ}
                                    onClick={toggleFAQ}
                                    className="btn-default btn-primary btn-toggle btn-drawer btn-drawer-alt"
                                    id="btn-online-personality-analyzer"
                                >
                                    <div className="row between-xs">
                                        <div className="col-xs col-no-gutter">
                                            <span className="btn-toggle-status sr-only">{!showFAQ ? "Show" : "Hide"}</span>
                                            <span className="btn-text">
                                                <span className="inline-drawer-icon">
                                                    <RenderIcons iconName="comments" />
                                                </span>{" "}
                                                Online Personality Analyzer FAQ
                                            </span>
                                        </div>
                                    </div>
                                </button>
                            </div>

                            <div className="drawer-content" id="online-personality-analyzer" aria-hidden="true">
                                <div className="col-xs flex-grow-null col-no-gutter">
                                    <input type="text" className="inputbox" placeholder="Search" onChange={filter} />
                                    <span className="input-group-text border-0" id="search-addon">
                                        <i className="fas fa-search"></i>
                                    </span>
                                </div>
                                {data
                                    .filter((name) => name.content.toLowerCase().includes(filterString) || name.header.toLowerCase().includes(filterString))
                                    .map((val: IAnswerSchema, index: number) => (
                                        <React.Fragment key={index}>
                                            {index === 0 ? (
                                                <div style={{ display: "block" }} className="drawer-container padding-horizontal-xs padding-vertical-s">
                                                    <div className="drawer-header">
                                                        <button
                                                            aria-expanded="false"
                                                            className="btn-default btn-toggle btn-table-drawer"
                                                            id={"btn-repfaq-" + index}
                                                            onClick={() => toggle("repfaq-" + index, "btn-repfaq-" + index)}
                                                        >
                                                            <span className="btn-toggle-status sr-only">Show</span>
                                                            <span className="btn-text">{val.header}</span>
                                                        </button>
                                                    </div>
                                                    <div className="drawer-content" id={"repfaq-" + index} style={{ display: "none" }}>
                                                        <h4 className="sr-only">{val.header}</h4>
                                                        <p>{val.content}</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{ display: showFAQ ? "block" : "none" }}
                                                    className="drawer-container padding-horizontal-xs padding-vertical-s"
                                                >
                                                    <div className="drawer-header">
                                                        <button
                                                            aria-expanded="false"
                                                            className="btn-default btn-toggle btn-table-drawer"
                                                            id={"btn-repfaq-" + index}
                                                            onClick={() => toggle("repfaq-" + index, "btn-repfaq-" + index)}
                                                        >
                                                            <span className="btn-toggle-status sr-only">Show</span>
                                                            <span className="btn-text">{val.header}</span>
                                                        </button>
                                                    </div>
                                                    <div className="drawer-content" id={"repfaq-" + index} style={{ display: "none" }}>
                                                        <h4 className="sr-only">{val.header}</h4>
                                                        <p>{val.content}</p>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="line-divider"></div>
                                        </React.Fragment>
                                    ))}
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default FAQ;
